export enum AssignmentStatus
{
    ToPlan = 0,
    Planned = 1,
    InTransit = 2,
    Completed = 3,
    JourneyWaypoint = 4,
    InStorage = 5,
    Received = 6,
    Cancelled = 7,
    UpdateReceived = 8
}

export const AssignmentStatusOptions = [
    {
        label: "core.assignment_status.to_plan",
        value: AssignmentStatus.ToPlan
    },
    {
        label: "core.assignment_status.planned",
        value: AssignmentStatus.Planned
    },
    {
        label: "core.assignment_status.in_transit",
        value: AssignmentStatus.InTransit
    },
    {
        label: "core.assignment_status.completed",
        value: AssignmentStatus.Completed
    },
    {
        label: "core.assignment_status.journey_waypoint",
        value: AssignmentStatus.JourneyWaypoint
    },
    {
        label: "core.assignment_status.in_storage",
        value: AssignmentStatus.InStorage
    },
    {
        label: "core.assignment_status.received",
        value: AssignmentStatus.Received
    },
    { label: "core.assignment_status.cancelled",
        value: AssignmentStatus.Cancelled
    },
    {
        label: "core.assignment_status.update_received",
        value: AssignmentStatus.UpdateReceived
    },
]
